import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const TemplatesBarWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  flex-shrink: 0;
  margin-top: 40px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 6px 40px;
  gap: 12px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.gray850};
    border-radius: 2px;
  }
`

export const TemplateChip = styled.button`
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
  color: ${colors.gray380};
  background: white;
  border: 1px solid ${colors.gray280};
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.2s ease;
  max-width: 100%;
  white-space: unset;
  text-align: start;

  &:hover {
    transform: scale(1.03);
    border: 1px solid ${colors.purple100};
  }
`
